import { render, staticRenderFns } from "./OtcInput.vue?vue&type=template&id=74a8ea90"
import script from "./OtcInput.vue?vue&type=script&lang=js"
export * from "./OtcInput.vue?vue&type=script&lang=js"
import style0 from "./OtcInput.vue?vue&type=style&index=0&id=74a8ea90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports